export const DATE_FORMAT = "DD-MM-YYYY hh:mm a";
export const PLACEHOLDER = "/public/images/resources/placeholder.png";
export const NOTFOUND = "/public/images/resources/notfound.png";
export const BANNER = "/public/images/resources/banner.jpg";
export const MASTERCARD = "/public/images/resources/master-card.png";
export const VISACARD = "/public/images/resources/visa-card.png";
export const PLACEHOLDER_CHALLENGE = "/public/images/resources/sports-login.png";
